import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';

/* =======================
 * Types
 * ======================= */

export interface ConsentType {
  id: number;
  key: string;
  name: string;
  description?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface ConsentTypeResponse extends BackendResponse {
  consent_type: ConsentType;
}

/* =======================
 * Query
 * ======================= */

export function useConsentType(typeId?: number | null) {
  return useQuery({
    queryKey: ['consent-type', typeId],
    queryFn: () => fetchConsentType(typeId as number),
    enabled: !!typeId, // ne lance pas si null/undefined/0
    staleTime: 1000 * 60 * 10, // 10 min (ça bouge quasi jamais)
  });
}

function fetchConsentType(typeId: number) {
  return apiClient
    .get<ConsentTypeResponse>(`consent-types/${typeId}`)
    .then(res => res.data.consent_type);
}
